/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ClienteCountDto interface.
 */
export function instanceOfClienteCountDto(value) {
    return true;
}
export function ClienteCountDtoFromJSON(json) {
    return ClienteCountDtoFromJSONTyped(json, false);
}
export function ClienteCountDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'idCliente': json['idCliente'] == null ? undefined : json['idCliente'],
        'nomeCliente': json['nomeCliente'] == null ? undefined : json['nomeCliente'],
        'count': json['count'] == null ? undefined : json['count'],
    };
}
export function ClienteCountDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'idCliente': value['idCliente'],
        'nomeCliente': value['nomeCliente'],
        'count': value['count'],
    };
}
